<template>
  <v-container>
    <v-card>
      <v-card-title class="d-flex justify-space-between">
        <v-btn color="error" text @click="$router.back()">
          <v-icon class="mx-2"> arrow_back </v-icon>
          back
        </v-btn>
        <v-btn
          @click="submitEmergency"
          class="white--text academic--button mr-4"
          color="indigo"
        >
          <v-icon class="mx-3">{{
            $route.query.edit !== undefined ? "edit" : "save"
          }}</v-icon>
          {{ $route.query.edit !== undefined ? "Edit" : "Submit" }}
        </v-btn>
        <v-card-text>
          <v-form v-model="isValid" ref="emergencyForm">
            <div class="text-lg-h6 mb-2">Contacts</div>
            <v-row>
              <v-col cols="12" md="4" sm="12" xs="12">
                <v-text-field
                  v-model="formData.name"
                  placeholder="Enter your name"
                  label="Name"
                  :rules="[rules.required]"
                  dense
                  persistent-placeholder
                  color="primary"
                  outlined
                  prepend-inner-icon="person"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="4" sm="12" xs="12">
                <v-text-field
                  v-model="formData.phoneNo"
                  placeholder="Enter phone Number"
                  label="Phone Number"
                  :rules="[rules.required]"
                  dense
                  color="primary"
                  persistent-placeholder
                  outlined
                  prepend-inner-icon="phone"
                  clearable
                />
              </v-col>
              <v-col cols="12" md="4" sm="12" xs="12">
                <v-text-field
                  v-model="formData.eMail"
                  placeholder="Enter  Email"
                  label="eMail"
                  :rules="[rules.required]"
                  persistent-placeholder
                  dense
                  color="primary"
                  outlined
                  prepend-inner-icon="mail"
                  clearable
                />
              </v-col>

              <v-col cols="12" md="4" sm="12" xs="12">
                <v-text-field
                  v-model="formData.address"
                  placeholder="Enter your address"
                  label="Address"
                  :rules="[rules.required]"
                  persistent-placeholder
                  dense
                  color="primary"
                  outlined
                  prepend-inner-icon="house"
                  clearable
                />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card-title>
    </v-card>
  </v-container>
</template>
<script>
import AuthService from "../../../dashboard/modules/auth/AuthService";
export default {
  name: "EmergencyComponent",
  data: function () {
    return {
      isValid: false,
      formData: {
        name: "",
        phoneNo: "",
        eMail: "",
        address: "",
      },
      rules: {
        required: (value) => !!value || "Required.",
        eMail: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+/.test(v) || "E-mail must be valid",
        ],
      },
    };
  },
  beforeRouteEnter(to, from, next) {
    next((v) => {
      if (to.query.edit !== undefined) {
        v.$store.dispatch("Profile/getContact", {
          lineNo: to.query.edit.toString(),
        });
      }
    });
  },
  computed: {
    emergency() {
      return this.$store.getters["Profile/contactGetters"]("contact");
    },
  },
  watch: {
    emergency() {
      this.formData = { ...this.emergency };
    },
  },
  methods: {
    submitEmergency() {
      if (!this.isValid) {
        this.$refs.emergencyForm.validate();
      } else {
        this.formData.profileID = AuthService.user.profile_id;
        this.$route.query.edit !== undefined
          ? this.$store.dispatch("Profile/editContact", { ...this.formData })
          : this.$store.dispatch("Profile/submitContact", {
              ...this.formData,
            });
      }
    },
  },
};
</script>
